var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHighPriority = function SvgHighPriority(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5286 3.52925C7.78894 3.2689 8.21106 3.2689 8.4714 3.52925L11.8047 6.86258C12.0651 7.12293 12.0651 7.54504 11.8047 7.80539C11.5444 8.06574 11.1223 8.06574 10.8619 7.80539L8 4.94346L5.13807 7.80539C4.87772 8.06574 4.45561 8.06574 4.19526 7.80539C3.93491 7.54504 3.93491 7.12293 4.19526 6.86258L7.5286 3.52925Z",
    fill: "#F15C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5286 8.19591C7.78894 7.93556 8.21106 7.93556 8.4714 8.19591L11.8047 11.5292C12.0651 11.7896 12.0651 12.2117 11.8047 12.4721C11.5444 12.7324 11.1223 12.7324 10.8619 12.4721L8 9.61013L5.13807 12.4721C4.87772 12.7324 4.45561 12.7324 4.19526 12.4721C3.93491 12.2117 3.93491 11.7896 4.19526 11.5292L7.5286 8.19591Z",
    fill: "#F15C5C"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHighPriority);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "high-priority.cbff97c1aad58327a66534256d1c217c.svg";